import { Component, ChangeDetectorRef } from "@angular/core";
import { FileUploader, FileItem } from "ng2-file-upload";
import { UtilitesService } from "app/base-module/base-service/utilites.service";
import { AuthService } from "app/base-module/base-service/auth.service";
import { BaseComponent } from "app/base-module/base-component/base.component";
import { FormControl, Validators } from "@angular/forms";
import { BoletaCoeService } from "app/renda-fixa/services/boleta-coe.service";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";


@Component({
    selector: "app-upload-coe",
    templateUrl: "./upload-coe.component.html",
    styleUrls: ["./upload-coe.component.scss"]
})

export class UploadCoeComponent extends BaseComponent {

    file:any;
    nomeFile:string | null;
    uploader: FileUploader;
    loadingLocal: any;



    tipo_importacao = new FormControl("DI", [Validators.required]);

    constructor(
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<UploadCoeComponent>,
        public service: BoletaCoeService,
        public utiliesService: UtilitesService,
        public authService: AuthService,
        private changeDetector: ChangeDetectorRef
    ) {

    super(dialog, snackBar);
    
    this.nomeFile = null;    

    this.uploader = new FileUploader({
      url: this.utiliesService.urlPrefix + "rendafixa/boleta-coe/upload",
      isHTML5: true,
      authToken: "Bearer " + this.authService.getToken()
    });

    this.uploader.onAfterAddingFile = (file) => { 
        file.withCredentials = false; 
    };
    
    this.uploader.onProgressItem = ( fileItem: FileItem, progress: any ) => { 
        this.changeDetector.detectChanges();
    };
    
    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      
      this.closeLoading();
      
      if (status == 200){
        var info = JSON.parse(response);
        
        this.showSuccess(info.message);
        
        this.dialogRef.close(info);
      }else{
        var info = JSON.parse(response);
        this.showError(info.message);
        //this.dialogRef.close("cancel");
      }
      
    };
    
  }

    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    uploadFile(event:any) {    //line 1

        //console.log(event);
        const elem = event.target;  //line 2
        //console.log(elem);
        if (elem.files.length > 0) {     //line 3
        this.file = elem.files[0];
        this.nomeFile = this.file.name;
        }
    }

    isNomeFile(){
        return (this.nomeFile != null);
    }

    save(){
        this.service.upload(this.file).subscribe(
        data => {
            console.log(data);
        },
        error => {
            console.log(error);
        },
        () => {
            
        }
        );
    }

    startUpload() {
        this.openLoading();
        this.uploader.queue[0].upload();
    }

}
